import { builderClient } from "../utils/builder";

export const getSEOModelData = async (urlPath) => {
    const model = 'seo'
    let resp;
    builderClient.setUserAttributes({
      userAttributes: {
        urlPath: urlPath,
      },
    })

    await builderClient.get(model).promise().then((data) => {
        if(typeof data != 'undefined'){
            resp = data.data;
        }else{
            resp = {};
        }
      });
    return resp;
  };
